module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp2_8023.be81eadd.png";